<template>
  <ripristinable-dialog v-model="isActive" @confirm="onConfirm" :title="$t('unita_mobili.messaggi.eliminato')">
    <v-flex xs12>
      <span class="mr-2">{{ $t('unita_mobili.label.targa') }}: </span>
      <b>{{ unitaMobile.targa }}</b>
    </v-flex>

    <v-flex xs12>
      <span class="mr-2">{{ $t('label.descrizione') }}: </span>
      <b>{{ unitaMobile.descrizione }}</b>
    </v-flex>
  </ripristinable-dialog>
</template>

<script>
import Toggleable from '@/mixins/toggleable'
import RipristinableDialog from '@/components/base/RipristinableDialog'

export default {
    name: 'UnitaMobileDeletedDialog',
    mixins: [Toggleable],
    components: { RipristinableDialog },
    data: () => ({
        unitaMobile: {}
    }),
    methods: {
        show (unitaMobile) {
            this.unitaMobile = unitaMobile
            this.isActive = true
        },
        onConfirm () {
            let vue = this
            this.$confirmDialog.show(
                this.unitaMobile.targa,
                this.$t('unita_mobili.messaggi.conferma_ripristino'),
                function (targa) {
                    this.$api.unitaMobili.restore(targa)
                        .then(() => {
                            vue.$snackbar.show(this.$t('unita_mobili.messaggi.ripristinato'), 'success')
                            vue.$emit('success')
                            vue.isActive = false
                        }).catch(e => {
                            if (e.response.status === 304) {
                                vue.$snackbar.show(this.$t('unita_mobili.errori.errore_ripristino'), 'error')
                            } else {
                                vue.$snackbar.showServerError(e)
                            }
                        })
                })
        }
    }
}
</script>
